import * as type from './types';

export function inConversationData(data) {
    return {
        type: type.GET_IN_CONVERSATION_DATA_REQUESTED,
        data: data,
    }
}